"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework base class for FactBoxForm controls
         * @internal
         */
        var FactBoxForm = /** @class */ (function (_super) {
            __extends(FactBoxForm, _super);
            function FactBoxForm(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // the test framework currently uses this to determine whether a factbox is expanded or not
                // and to expand a factbox before attaching to it
                _this.Expanded = $dyn.value(_this.Part).Expanded;
                return _this;
            }
            return FactBoxForm;
        }($dyn.controls.PartForm));
        controls.FactBoxForm = FactBoxForm;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FactBoxForm.js.map
